import React, { useState, useEffect } from "react";
import styles from "./galeria_vieiratattoo_.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes, FaArrowUp } from "react-icons/fa";

// Import das imagens
import PretoEBranco1 from './src/galeria/pretoebranco1.jpeg';
import PretoEBranco2 from './src/galeria/pretoebranco2.jpeg';
import PretoEBranco3 from './src/galeria/pretoebranco3.jpeg';
import PretoEBranco4 from './src/galeria/pretoebranco4.jpeg';
import PretoEBranco5 from './src/galeria/pretoebranco5.jpeg';
import PretoEBranco6 from './src/galeria/pretoebranco6.jpeg';
import PretoEBranco7 from './src/galeria/pretoebranco7.jpeg';
import PretoEBranco8 from './src/galeria/pretoebranco8.jpeg';
import PretoEBranco9 from './src/galeria/pretoebranco9.jpeg';
import PretoEBranco10 from './src/galeria/pretoebranco10.jpeg';
import PretoEBranco11 from './src/galeria/pretoebranco11.jpeg';
import PretoEBranco12 from './src/galeria/pretoebranco12.jpeg';
import PretoEBranco13 from './src/galeria/pretoebranco13.jpeg';
import PretoEBranco14 from './src/galeria/pretoebranco14.jpeg';
import PretoEBranco15 from './src/galeria/pretoebranco15.jpeg';
import PretoEBranco16 from './src/galeria/pretoebranco16.jpeg';
import PretoEBranco17 from './src/galeria/pretoebranco17.jpeg';
import PretoEBranco18 from './src/galeria/pretoebranco18.jpeg';
import PretoEBranco19 from './src/galeria/pretoebranco19.jpeg';
import PretoEBranco20 from './src/galeria/pretoebranco20.jpeg';
import PretoEBranco21 from './src/galeria/pretoebranco21.jpeg';
import PretoEBranco22 from './src/galeria/pretoebranco22.jpeg';
import PretoEBranco23 from './src/galeria/pretoebranco23.jpeg';
import PretoEBranco24 from './src/galeria/pretoebranco24.jpeg';
import PretoEBranco25 from './src/galeria/pretoebranco25.jpeg';
import PretoEBranco26 from './src/galeria/pretoebranco26.jpeg';
import PretoEBranco27 from './src/galeria/pretoebranco27.jpeg';
import PretoEBranco28 from './src/galeria/pretoebranco28.jpeg';
import PretoEBranco29 from './src/galeria/pretoebranco29.jpeg';
import PretoEBranco30 from './src/galeria/pretoebranco30.jpeg';
import PretoEBranco31 from './src/galeria/pretoebranco31.jpeg';
import PretoEBranco32 from './src/galeria/pretoebranco32.jpeg';
import PretoEBranco33 from './src/galeria/pretoebranco33.jpeg';
import PretoEBranco34 from './src/galeria/pretoebranco34.jpeg';
import PretoEBranco35 from './src/galeria/pretoebranco35.jpeg';
import PretoEBranco36 from './src/galeria/pretoebranco36.jpeg';
import PretoEBranco37 from './src/galeria/pretoebranco37.jpeg';
import PretoEBranco38 from './src/galeria/pretoebranco38.jpeg';
import PretoEBranco39 from './src/galeria/pretoebranco39.jpeg';
import PretoEBranco40 from './src/galeria/pretoebranco40.jpeg';
import PretoEBranco41 from './src/galeria/pretoebranco41.jpeg';
import PretoEBranco42 from './src/galeria/pretoebranco42.jpeg';
import Colorida1 from './src/galeria/colorida1.jpeg';
import Colorida2 from './src/galeria/colorida2.jpeg';
import Colorida3 from './src/galeria/colorida3.jpeg';
import Colorida4 from './src/galeria/colorida4.jpeg';
import Colorida5 from './src/galeria/colorida5.jpeg';
import Colorida6 from './src/galeria/colorida6.jpeg';
import Colorida7 from './src/galeria/colorida7.jpeg';
import Colorida8 from './src/galeria/colorida8.jpeg';
import Colorida9 from './src/galeria/colorida9.jpeg';
import Colorida10 from './src/galeria/colorida10.jpeg';
import Colorida11 from './src/galeria/colorida11.jpeg';
import Colorida12 from './src/galeria/colorida12.jpeg';
import Colorida13 from './src/galeria/colorida13.jpeg';
import Colorida14 from './src/galeria/colorida14.jpeg';
import Colorida15 from './src/galeria/colorida15.jpeg';
import Colorida16 from './src/galeria/colorida16.jpeg';
import Colorida17 from './src/galeria/colorida17.jpeg';
import Colorida18 from './src/galeria/colorida18.jpeg';
import Colorida19 from './src/galeria/colorida19.jpeg';
import Colorida20 from './src/galeria/colorida20.jpeg';
import Colorida21 from './src/galeria/colorida21.jpeg';
import Colorida22 from './src/galeria/colorida22.jpeg';
import Colorida23 from './src/galeria/colorida23.jpeg';
import Colorida24 from './src/galeria/colorida24.jpeg';
import Colorida25 from './src/galeria/colorida25.jpeg';
import Colorida26 from './src/galeria/colorida26.jpeg';
import Colorida27 from './src/galeria/colorida27.jpeg';
import Colorida28 from './src/galeria/colorida28.jpeg';
import Colorida29 from './src/galeria/colorida29.jpeg';
import Colorida30 from './src/galeria/colorida30.jpeg';
import Colorida31 from './src/galeria/colorida31.jpeg';
import Colorida32 from './src/galeria/colorida32.jpeg';
import Colorida33 from './src/galeria/colorida33.jpeg';
import Colorida34 from './src/galeria/colorida34.jpeg';
import Colorida35 from './src/galeria/colorida35.jpeg';
import Colorida36 from './src/galeria/colorida36.jpeg';
import Colorida37 from './src/galeria/colorida37.jpeg';
import Colorida38 from './src/galeria/colorida38.jpeg';

const Galeria_vieiratattoo_: React.FC = () => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [categoria, setCategoria] = useState<"pretoebranco" | "colorida">("pretoebranco");
    const [showScrollTop, setShowScrollTop] = useState(false);

    // Listas de imagens separadas por categoria
    const imagensPretoEBranco = [PretoEBranco1, PretoEBranco2, PretoEBranco3, PretoEBranco4, PretoEBranco5, PretoEBranco6, PretoEBranco7, PretoEBranco8, PretoEBranco9, PretoEBranco10, PretoEBranco11, PretoEBranco12, PretoEBranco13, PretoEBranco14, PretoEBranco15, PretoEBranco16, PretoEBranco17, PretoEBranco18, PretoEBranco19, PretoEBranco20, PretoEBranco21, PretoEBranco22, PretoEBranco23, PretoEBranco24, PretoEBranco25, PretoEBranco26, PretoEBranco27, PretoEBranco28, PretoEBranco29, PretoEBranco30, PretoEBranco31, PretoEBranco32, PretoEBranco33, PretoEBranco34, PretoEBranco35, PretoEBranco36, PretoEBranco37, PretoEBranco38, PretoEBranco39, PretoEBranco40, PretoEBranco41, PretoEBranco42];
    const imagensColoridas = [Colorida1, Colorida2, Colorida3, Colorida4, Colorida5, Colorida6, Colorida7, Colorida8, Colorida9, Colorida10, Colorida11, Colorida12, Colorida13, Colorida14, Colorida15, Colorida16, Colorida17, Colorida18, Colorida19, Colorida20, Colorida21, Colorida22, Colorida23, Colorida24, Colorida25, Colorida26, Colorida27, Colorida28, Colorida29, Colorida30, Colorida31, Colorida32, Colorida33, Colorida34, Colorida35, Colorida36, Colorida37, Colorida38];

    // Seleciona a lista atual com base na categoria
    const imagensAtuais = categoria === "pretoebranco" ? imagensPretoEBranco : imagensColoridas;

    const openLightbox = (index: number) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);
    const prevImage = () =>
        setCurrentIndex((prev) => (prev === 0 ? imagensAtuais.length - 1 : prev - 1));
    const nextImage = () =>
        setCurrentIndex((prev) => (prev === imagensAtuais.length - 1 ? 0 : prev + 1));

    // --- Mostrar botão "voltar ao topo" após rolar ---
    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className={styles.galeria_vieiratattoo_}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/vieiratattoo_" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Galeria</h1>
            </div>

            {/* FILTRO - Preto e Branco / Coloridas */}
            <div className={styles.filterBar}>
                <button
                    className={`${styles.filterButton} ${categoria === "pretoebranco" ? styles.active : ""
                        }`}
                    onClick={() => setCategoria("pretoebranco")}
                >
                    Preto e Branco
                </button>
                <button
                    className={`${styles.filterButton} ${categoria === "colorida" ? styles.active : ""
                        }`}
                    onClick={() => setCategoria("colorida")}
                >
                    Coloridas
                </button>
            </div>

            {/* CONTEÚDO - Galeria */}
            <div className={styles.content}>
                <div className={styles.galleryGrid}>
                    {imagensAtuais.map((img, index) => (
                        <div
                            key={index}
                            className={styles.imageContainer}
                            onClick={() => openLightbox(index)}
                        >
                            <img src={img} alt={`${categoria} ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <div className={styles.lightbox}>
                    <button className={styles.closeBtn} onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button className={styles.prevBtn} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img
                        src={imagensAtuais[currentIndex]}
                        alt={`${categoria} ${currentIndex + 1}`}
                        className={styles.lightboxImage}
                    />
                    <button className={styles.nextBtn} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}

            {/* BOTÃO FLUTUANTE */}
            {showScrollTop && (
                <button className={styles.scrollTopButton} onClick={scrollToTop}>
                    <FaArrowUp />
                </button>
            )}

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a
                        href="https://wa.me/5518998237233?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <WhatsappIcon height="30" color="#ffffff" />
                            </div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/QMDr4ePwxg1aKptT8" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <MapsIcon height="30" color="#ffffff" />
                            </div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a
                        href="https://www.instagram.com/vieiratattoo_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Galeria_vieiratattoo_;
